// @flow
import Placement from "./placement";

"use strict";

/**
 * 環境情報
 */
export default class Environment {
  constructor(mode: string, akamaiHost: string, akamaiTagDirectory: string, adServerEndPoint: string){
    this.mode = mode; // 実行環境文字列 local|development|staging|production
    this.akamaiHost = akamaiHost; // (dev-|staging-| )speee-ad.akamaized.net
    this.akamaiTagDirectory = akamaiTagDirectory; // this.akamaiHost/tag
    this.adServerEndPoint = adServerEndPoint; // 配信サーバエンドポイント(dev-|staging-| )click.speee-ad.jp
  }

  static create(mode: string): Environment{
    let envPrefix = '';
    let akamaiHost = `speee-ad.akamaized.net`;
    let adServerEndPoint = `click.speee-ad.jp`;
    let adServerPath = `/v1/recwid`;
    let akamaiTagDirectory = ``;

    switch(mode){
      case 'test':
      case 'local':
        akamaiHost = `//dev-${akamaiHost}`;
        adServerEndPoint = `//localhost:8081${adServerPath}`;
        break;
      case 'development':
        envPrefix = 'dev';
        akamaiHost = `//${envPrefix}-${akamaiHost}`;
        akamaiTagDirectory = `${akamaiHost}/tag`;
        adServerEndPoint = `//${envPrefix}-${adServerEndPoint}${adServerPath}`;
        break;
      case 'staging':
        envPrefix = 'staging';
        akamaiHost = `//${envPrefix}-${akamaiHost}`;
        akamaiTagDirectory = `${akamaiHost}/tag`;
        adServerEndPoint = `//${envPrefix}-${adServerEndPoint}${adServerPath}`;
        break;
      case 'production':
        akamaiHost = `//${akamaiHost}`;
        akamaiTagDirectory = `${akamaiHost}/tag`;
        adServerEndPoint = `//${adServerEndPoint}${adServerPath}`;
        break;
      default:
        throw new Error(`environment should be any one of [local|development|staging|production|test].`);
    }

    return new Environment(mode, akamaiHost, akamaiTagDirectory, adServerEndPoint);
  }

  isLocal(): boolean{
    return this.mode === 'local';
  }

  isDevelopment(): boolean{
    return this.mode === 'development';
  }

  isStaging(): boolean{
    return this.mode === 'staging';
  }

  isProduction(): boolean{
    return this.mode === 'production';
  }

  isTest(): boolean{
    return this.mode === 'test';
  }

  getPlacementTagPath(placement: Placement, window: Window): string{
    if (this.isLocal() || this.isTest()){
      return `//${window.location.host}/`;
    }
    return `${this.akamaiTagDirectory}/${placement.code}/`;
  }

}


// WEBPACK FOOTER //
// ./src/js/model/common/environment.js